
import { LOCATION_CHANGE, routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

// import schemaReducer from './schema/schemaReducer';
import activeReducer from 'core/reducers/activeReducer';
import ajaxReducer from 'core/reducers/ajax/ajaxStatusReducer';
import configReducer from 'core/reducers/config/configReducer';
import paramsReducer from 'core/reducers/paramsReducer';
import { ExternalCallbackRegistry } from 'core/util/IExternalCallback';
import cartReducer from "./cartReducer";
import dictionaryReducer from './dictionary/dictionaryReducer';
import editReducer from './editReducer';
import initializationReducer from "./initialization/initializationReducer";
import layoutReducer from './layout/layoutReducer';
import userReducer from './user/userReducer';
import pageSizeReducer from './pageSizeReducer';

/**
 * @overview: Combines reducer. Make sure to add any new reduces created here.
 *
 * @author: jesposito
 */

const rootReducer = combineReducers({
	config: configReducer,
	ajaxReducer,
	router: routerReducer,
	/* apollo: apolloClient.reducer(), */
	params: paramsReducer,
	// schemas: schemaReducer,
	layout: layoutReducer,
	active: activeReducer,
	edit: editReducer,
	initialization: initializationReducer,
	dictionary: dictionaryReducer,
	cart: cartReducer,
	user: userReducer,
	pageSize: pageSizeReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/core/reducers/root.ts